module.exports = __webpack_public_path__ + "fonts/Inter-MediumItalic.417907d.woff";